"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRadiumStyleState = function getRadiumStyleState(component) {
  return component._lastRadiumState || component.state && component.state._radiumStyleState || {};
};

exports.default = getRadiumStyleState;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/radium/lib/get-radium-style-state.js
// module id = 230
// module chunks = 0